import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginPageComponent} from './login-page.component';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzGridModule} from 'ng-zorro-antd/grid';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzFormModule} from 'ng-zorro-antd/form';


@NgModule({
  declarations: [LoginPageComponent],
  imports: [
    CommonModule,
    NzCardModule,
    NzTabsModule,
    NzGridModule,
    NzButtonModule,
    RouterModule,
    ReactiveFormsModule,
    NzInputModule,
    NzFormModule
  ]
})
export class LoginModule {
}
